





































import Vue from "vue";
import Combo from "./combo.vue";

export type callFilterEmit = {
  tagsSelected: string[];
  center: number;
  duration: string;
};

export default Vue.extend({
  components: { Combo },
  data() {
    return {
      filters: { tagsSelected: [], center: 0, duration: "" } as callFilterEmit,
    };
  },
  methods: {
    addTags(tag: string) {
      this.$emit("addTags", tag);
    },
    removeTag(tag: string) {
      this.$emit("RemoveTag", tag);
    },
  },
  computed: {
    filterText(): string {
      const filters = this.filters;
      if (filters) {
        let cadena = "";
        if (filters.tagsSelected.length > 0) {
          const filtersText = filters.tagsSelected.map((tag: string) => {
            return `${tag}`;
          });
          cadena += `Etiquetas: ${filtersText.join(" ,").trim()} `;
        }
        return cadena;
      }
      return "";
    },
  },
  props: {
    open: Boolean,
    selecttag: [],
  },
  filters: {},
});
